export class ErrorUtils {
    static getMessage(e: any): string {
        if (e instanceof Error) {
            return e.message
        } else if (typeof e === 'string') {
            return e
        }

        return e.toString()
    }
}

export default ErrorUtils
